import Vue from 'vue'
import VueRouter from 'vue-router'
// 后台管理
import HtView from '../views/HtView.vue'
import qt_home from '../views/qt_home.vue'


Vue.use(VueRouter)

const routes = [
	// 共享平台
	{
		path: '/',
		component: qt_home,
		redirect: '/index',
		// 子页面
		children: [{
			path: 'index',
			component: () => import('@/views/Qt/index.vue')
		}, {
			path: 'wdang',
			component: () => import('@/views/Qt/wdang.vue')
		}, {
			path: 'zsk',
			component: () => import('@/views/Qt/zsk.vue')
		}, {
			path: 'wdangS/:article_id',
			component: () => import('@/views/Qt/wdangS.vue')
		}, {
			path: 'qtsoft',
			component: () => import('@/views/Qt/download/soft.vue')
		}, {
			path: 'history',
			component: () => import('@/views/Qt/download/history.vue')
		}]

	},
	// 后台管理
	{
		path: '/HtView',
		component: HtView,
	},
	{ // 分类管理 - 一级菜单管理
		path: '/ht_categ',
		component: () => import('@/views/children/ht_categ.vue')
	}, { // 员工管理 - 一级菜单管理
		path: '/user',
		component: () => import('@/views/children/user.vue')
	}, { // 软件管理
		path: '/soft',
		component: () => import('@/views/children/soft.vue')
	}, { // 知识库数据
		path: '/articleList/:categ_id',
		component: () => import('@/views/children/articleList.vue')
	}, { // 知识库数据
		path: '/articleList2',
		component: () => import('@/views/children/articleList2.vue')
	}, { // 添加富文本内容
		path: '/richText',
		component: () => import('@/views/children/richText.vue')
	}, { // 文章回收站
		path: '/articleRecycle',
		component: () => import('@/views/children/articleRecycle.vue')
	}, { // 分类回收站
		path: '/categRecycle',
		component: () => import('@/views/children/categRecycle.vue')
	}



]



const router = new VueRouter({
	routes
})
router.beforeEach((to, from, next) => {
	// 每次路由切换时，回到顶部
	window.scrollTo(0, 0);
	next();
  })

export default router
